<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Pagina di login per il servizio -->
    <SalabamLoginPage :service_title="service_title" :service_name="service_name"/>
  </div>
</template>

<script>

import PageTagline from "@/components/PageTagline.vue";
import SalabamLoginPage from "@/components/salabam/SalabamLoginPage.vue";

export default {
  name: 'SalabamTravelTrain',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Treni Vadobay", link : 'conv-salabam-travel-train' } ],

      // variabili che definiscono il servizio Booking con la quale
      // configuriamo la pagina di login.
      service_title: "Treni Vadobay",
      service_name: "travel-train",
    }
  },
  components: {
    PageTagline,
    SalabamLoginPage
  }
}
</script>

<style scoped></style>